import { render } from "./ParticleWave.vue?vue&type=template&id=259d18fa"
import script from "./ParticleWave.vue?vue&type=script&lang=js"
export * from "./ParticleWave.vue?vue&type=script&lang=js"

import "./ParticleWave.vue?vue&type=style&index=0&id=259d18fa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__